import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// --- Service worker registration (offline fallback only) ---
// Registers /sw.js in production so users see a branded /offline.html when
// the network is unreachable. Skips localhost & dev to keep hot-reload sane.
if ('serviceWorker' in navigator && window.location.hostname !== 'localhost') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* silently ignore — offline page is a progressive enhancement */
    });
  });
}
// Remember the current path so offline.html can bounce the user back
// once connectivity returns.
try {
  const remember = () => {
    try { sessionStorage.setItem('civilx:last_path', window.location.pathname + window.location.search); } catch (_e) { /* noop */ }
  };
  remember();
  window.addEventListener('popstate', remember);
} catch (_e) { /* noop */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
